


















































import Vue from 'vue';
import { dateFormat, dateTransactionFormat } from '@/constants';
import { CloseFullscreenWrapper, TriggerRefreshError } from '@/mixins';
import {
  FullscreenWrapper,
  FullscreenContent,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { ExtendMixins } from '@/services';
import { PendingTransactionResponseModel } from '@/@types/member';

interface Data {
  isLoading: boolean;
  showSuccessMessage: boolean;
  successMessage: string;
  showErrorMessage: boolean;
  errorMessage: string;
  dateFormat: string;
  dateTransactionFormat: string;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  TriggerRefreshError,
).extend({
  name: 'CancelPendingInvestment',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      isLoading: false,
      showSuccessMessage: false,
      successMessage: this.params.successMessage,
      showErrorMessage: false,
      errorMessage: this.params.errorMessage,
      dateFormat,
      dateTransactionFormat,
    };
  },
  computed: {
    transactions(): PendingTransactionResponseModel[] {
      return this.$store.getters.pendingTransactions;
    },
    selectedTransaction(): PendingTransactionResponseModel {
      const filteredActivity = this.transactions.filter((activity) => {
        return (
          activity.transactionId.toString() ===
          this.params.transactionId.toString()
        );
      });
      return filteredActivity.length ? filteredActivity[0] : null;
    },
    selectedTransactionDescriptionProps(): any {
      if (!this.selectedTransaction) { return {}; }
      return {
        description: this.selectedTransaction.description,
        amount: this.varReplaceAmount,
      };
    },
    varReplaceAmount(): string {
      if (!this.selectedTransaction) { return ''; }
      return this.$options.filters.currency(
        this.selectedTransaction.paymentAmount,
      );
    },
  },
  methods: {
    cancel(): void {
      this.isLoading = true;
      this.$store
        .dispatch(
          'deletePendingInvestment',
          this.selectedTransaction.transactionId,
        )
        .then(() => {
          this.refreshTransactions();
        })
        .catch(() => {
          this.showErrorMessage = true;
          this.isLoading = false;
        });
    },
    refreshTransactions(): void {
      this.$store
        .dispatch('getAccountTransactions', this.$route.params.id)
        .then(() => {
          this.showSuccessMessage = true;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.triggerRefreshError({
            message: [
              'cancel-pending-investment_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
        });
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenContent,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
});
